import { Injectable, inject } from '@angular/core';
import { DataService } from '../../../../core/services/data.service';
import { Observable } from 'rxjs';
import { ICourseAttachment } from '../interface/icourse-attachment';
import { ICourseStatus } from '../interface/icourse-status';
import { IUserCourses } from '@core/interfaces/iuser-courses';

@Injectable({
  providedIn: 'root'
})
export class CoursesService {
  dataService = inject(DataService);

  saveAttachment(attachment: FormData): Observable<boolean>  {
    return this.dataService.post('courseAttachment', attachment);
  }

  getAttachments(courseId: number): Observable<ICourseAttachment[]> {
    return this.dataService.get(`courseAttachment/${courseId}`);
  }

  getUserCourse(userCourseId: number): Observable<IUserCourses> {
    return this.dataService.get(`userCourse/course/${userCourseId}`);
  }

  completeCourse(courseId: number): Observable<boolean> {
    return this.dataService.post(`userCourse/complete/${courseId}`, {});
  }

  addUserCourse(courseId: number): Observable<boolean> {
    return this.dataService.post(`userCourse/add/${courseId}`, {});
  }

  acknowledgeCourse(courseId: number): Observable<boolean> {
    return this.dataService.post(`userCourse/acknowledge/${courseId}`, {});
  }

  downloadCertificate(courseId: number): Observable<any> {
    return this.dataService.postWithOptions(`userCourse/download-certificate/${courseId}`, {}, {
      responseType: 'blob'
    });
  }

  updateCourse(course: FormData): Observable<boolean> {
    return this.dataService.put('course', course);
  }

  deleteAttachment(attachmentId: number): Observable<boolean> {
    return this.dataService.delete(`courseAttachment/delete-attachment?id=${attachmentId}`);
  }

  getCourseStatus(courseId: number): Observable<ICourseStatus> {
    return this.dataService.get(`userCourse/course-status/${courseId}`);
  }

  getAllUserCompletedCourses(payload: any): Observable<IUserCourses[]> {
    return this.dataService.get(`userCourse/completed/school-year/${payload.schoolYearId}/user/${payload.userId}`);
  }
}
